import {DefaultErrorOverlay} from '@ael/shared-components-library';
import React from 'react';

export const TrackingNotInitializedErrorOverlay = () => {
  return (
    <DefaultErrorOverlay
      title="Tracking not initialized"
      description={
        <p>
          Apologies, but tracking for this course was not initialized.
        </p>
      }
    />
  );
};
